import type { Profile } from '../../types/Profile';

export const profileBaseFeatureConfig: Profile = {
    version: 1,
};
